import React from 'react'
import InputMessageBottom from './InputMessageBottom'
import { InputProps, Input as AntInput } from 'antd'
import Box from './Box'
import { FormikValues } from 'formik'
import { getInputProps } from '../../utils/fields'
import InputLabel from '@ui/InputLabel'

interface Props extends Omit<InputProps, 'form'> {
  message?: string
  error?: boolean
  form?: FormikValues
  rows?: number
  label?: string
}

const TextArea = ({ error, message, form, label, ...props }: Props) => {
  const commonProps = form && props.name ? getInputProps(form, props.name) : {}

  return (
    <Box>
      {label && <InputLabel>{label}</InputLabel>}
      <AntInput.TextArea
        {...commonProps}
        {...props}
        status={error || commonProps.error ? 'error' : undefined}
      />
      <InputMessageBottom
        error={commonProps.error || error}
        message={commonProps.message || message}
      />
    </Box>
  )
}

export default TextArea
